import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";

import { useResponsive } from "src/hooks/use-responsive";

import { bgGradient } from "src/theme/css";
import { useAuthContext } from "src/auth/hooks";

import Logo from "src/components/logo";
import Card from "@mui/material/Card/Card";
import Iconify from "src/components/iconify";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
// ----------------------------------------------------------------------

type Props = {
  title?: string;
  image?: string;
  children: React.ReactNode;
};

export default function AuthLoginLayout({ children }: Props) {
  const { method } = useAuthContext();
  const { t } = useTranslation();
  const theme = useTheme();

  const mdUp = useResponsive("up", "md");

  const renderLogo = (
    <Logo
      sx={{
        zIndex: 9,
        position: "absolute",
        m: { xs: 2, md: 5 },
        width: 120,
      }}
    />
  );

  const renderSection = (
    <Stack
      sx={{
        width: 1,
        mx: "auto",
        maxWidth: 400,
        px: { xs: 2, md: 8 },
        pt: { xs: 15, md: 20 },
        pb: { xs: 15, md: 0 },
      }}
    >
      <Typography variant="subtitle1" sx={{ textAlign: "left", mb: 3 }}>
        {t("login_to_the_world_of_sports")}
      </Typography>

      <Stack key={"findmate"} spacing={1} direction="row" sx={{ my: 2 }}>
        <Stack>
          <Iconify
            icon="solar:calendar-date-bold"
            sx={{ color: "cadetblue", mt: 0 }}
          />
        </Stack>
        <Stack>
          <Typography variant="subtitle1">{t("find_a_partner")}</Typography>

          <Typography variant="body2" sx={{ mt: 1 }}>
            {t("find_a_partner_description")}
          </Typography>
        </Stack>
      </Stack>

      <Stack key={"move"} spacing={1} direction="row" sx={{ my: 2 }}>
        <Stack>
          <Iconify
            icon="solar:calendar-date-bold"
            sx={{ color: "cadetblue", mt: 0 }}
          />
        </Stack>
        <Stack>
          <Typography variant="subtitle1">{t("do_sports")}</Typography>

          <Typography variant="body2" sx={{ mt: 1 }}>
            {t("do_sports_description")}
          </Typography>
        </Stack>
      </Stack>

      <Stack key={"admin"} spacing={1} direction="row" sx={{ my: 2 }}>
        <Stack>
          <Iconify
            icon="solar:calendar-date-bold"
            sx={{ color: "cadetblue", mt: 0 }}
          />
        </Stack>
        <Stack>
          <Typography variant="subtitle1">
            {t("administrate_reservations_online")}
          </Typography>

          <Typography variant="body2" sx={{ mt: 1 }}>
            {t("administrate_reservations_online_description")}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );

  const renderContent = (
    <Stack
      flexGrow={1}
      spacing={10}
      alignItems="center"
      justifyContent="center"
      sx={{
        ...bgGradient({
          color: alpha(
            theme.palette.background.neutral,
            //theme.palette.mode === "light" ? 0.88 : 0.94
            theme.palette.mode === "light" ? 0 : 0
          ),
          imgUrl: "/assets/images/hero_image_02.jpg",
        }),
      }}
    >
      <Card sx={{ m: { xs: 3, md: 10 }, mt: { xs: 12, md: 5 } }}>
        {children}
      </Card>
    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: "100vh",
      }}
    >
      {renderLogo}

      {mdUp && renderSection}

      {renderContent}
    </Stack>
  );
}
